import { all, call, fork, put } from 'redux-saga/effects';

import api from 'Gateway';
import { createMarker, deleteMarker } from 'Services/learnkit';

import { GET_VS_MARKERS } from 'Pipelines/actions';
import { SAVE_MARKERS } from 'Reducers/dataModels/markers';
import { SAVE_DEFAULT_SELECTEDHIGHLIGHT } from 'Reducers/dataModels/selectedHighlight';

function sortMarkers(markers) {
  return markers.sort((a, b) => {
    return a.sortOrder > b.sortOrder;
  });
}

function* createMarkers(markers) {
  const createMarkerCalls = markers.map(marker => createMarker(marker));
  yield Promise.all(createMarkerCalls);
}

function* deleteMarkers(markers) {
  const deleteMarkerCalls = markers.map(marker => deleteMarker(marker.globalId));
  yield Promise.all(deleteMarkerCalls);
}

function getDefaultSelectedHighlight(marker) {
  return {
    color: marker.color,
    darkColor: marker.darkColor,
    id: '',
    label: marker.label,
    markerId: marker.id,
    noteText: ''
  };
}

function* filterMarkers(vsMarkers, userMarkers) {
  let cloneUserMarkers = [ ...userMarkers ];
  let addVsMarkers = [];
  let deleteVsMarkers = [];
  let keepVsMarkers = [];
  let userMarkersToSetState = [];

  for (const vsMarker of vsMarkers) {

    const keep = cloneUserMarkers.filter(userMarker => {
      return userMarker.color === vsMarker.vstColor &&
             userMarker.color === vsMarker.color &&
             userMarker.label === vsMarker.label &&
             userMarker.darkColor === vsMarker.vstColorDark;
    });

    if (keep.length === 0) {
      deleteVsMarkers.push(vsMarker);
    } else {

      keepVsMarkers.push(keep[0]);
      userMarkersToSetState.push({ ...keep[0], id: vsMarker.globalId });

      cloneUserMarkers = cloneUserMarkers.filter(_userMarker => {
        return _userMarker.color !== keep[0].color;
      });
    }
  }

  if (keepVsMarkers.length === 0 && (vsMarkers.length === deleteVsMarkers.length) ) {
    addVsMarkers = userMarkers;
  }

  if (keepVsMarkers.length !== 0) {
    const keepVsMarkersSet = new Set(keepVsMarkers);

    addVsMarkers = userMarkers.filter(userMarker => {
      return !keepVsMarkersSet.has(userMarker);
    });
  }

  return { addVsMarkers, deleteVsMarkers, userMarkersToSetState };
}

function* markers(vsMarkers) {
  try {
    const userMarkers = yield api.settings.getUserMarkers();

    const { addVsMarkers, deleteVsMarkers, userMarkersToSetState } = yield filterMarkers(vsMarkers, userMarkers);

    const addLength = addVsMarkers.length;
    const delLength = deleteVsMarkers.length;
    const userLength = userMarkersToSetState.length;

    if (addLength > 0 && userLength !== 4) {
      yield call(createMarkers, addVsMarkers);
      if (delLength > 0) {
        yield call(deleteMarkers, deleteVsMarkers);
      }
      yield put({ type: GET_VS_MARKERS });
    }

    if (addLength === 0 && userLength === 4) {
      const sortedMarkers = sortMarkers(userMarkersToSetState);
      const defaultSelectedHighlight = getDefaultSelectedHighlight(sortedMarkers[0]);
      if (delLength > 0)  {
        yield fork(deleteMarkers, deleteVsMarkers);
      } 
      yield all([
        put({ type: SAVE_DEFAULT_SELECTEDHIGHLIGHT, data: defaultSelectedHighlight }),
        put({ type: SAVE_MARKERS, data: sortedMarkers })
      ]);
    }
  } catch (err) {
    console.error('Normalize Markers:', err);
    debugger;
  }
}


export default markers;
